import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { ServiceInformationRoutingModule } from './service-information-routing.module';
import { ServiceInformationComponent } from './service-information.component';


@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    ServiceInformationRoutingModule,
    MatIconModule
  ],
  declarations: [
    ServiceInformationComponent
  ],
  exports: [
    ServiceInformationComponent
  ]
})
export class ServiceInformationModule { }